import { render, staticRenderFns } from "./FornecedoresDialogAlterar.vue?vue&type=template&id=15b1be4a&"
import script from "./FornecedoresDialogAlterar.vue?vue&type=script&lang=ts&"
export * from "./FornecedoresDialogAlterar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports